export function Popup({status,children}) {
    
  return (
    <>
        <div style={{position:"fixed",top:"0",left:"0",zIndex:"9999999",height:"100vh",width:"100vw",backgroundColor:"rgb(0 0 0 / 91%)", display: status === true ? "flex" : "none",}}>
            <div style={{maxWidth:"100vw",width:"calc(100vw - 50px)",margin:"50px auto",alignSelf:"center"}}>
                {children}
            </div>
        </div>
    </>
    );
}
